import { Action, State, StateContext } from '@ngxs/store';

import { Recurring } from './recurring.model';
import * as RecurringActions from './recurring.actions';

@State<Recurring>({
  name: 'recurring',
  defaults: new Recurring()
})
export class RecurringState {
  @Action(RecurringActions.SetStartDate)
  setStartDate(
    { getState, setState }: StateContext<Recurring>,
    { payload }: RecurringActions.SetStartDate
  ) {
    setState({ ...getState(), startDate: payload });
  }
  @Action(RecurringActions.SetCount)
  setCount(
    { getState, setState }: StateContext<Recurring>,
    { payload }: RecurringActions.SetCount
  ) {
    setState({ ...getState(), count: payload.count });
  }
  @Action(RecurringActions.SetEndDate)
  setEndDate(
    { getState, setState }: StateContext<Recurring>,
    { payload }: RecurringActions.SetEndDate
  ) {
    setState({ ...getState(), endDate: payload.date, count: payload.count });
  }
  @Action(RecurringActions.SetFrequency)
  setFrequency(
    { getState, setState }: StateContext<Recurring>,
    { payload }: RecurringActions.SetFrequency
  ) {
    setState({ ...getState(), frequency: payload });
  }
}
